import { SUBMIT_FORM } from '../action-types.js';

export const onFormSubmit = (formName) => (action) => action.type === SUBMIT_FORM && action.meta.formName === formName;

export const onFormSuccess = (formName) => (action) =>
  action.type === `${SUBMIT_FORM}_SUCCESS` && action.meta.formName === formName;
